import { Fragment } from 'react';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { renderLogo } from 'src/utils/renderLogo';
import { providers } from 'src/shared/entities';
import { cn } from 'src/lib/utils';
import { Separator } from '@/components/ui/separator';

type Props = {
  integration: {
    provider: string;
    account: string;
  };
  onConfirm: () => void;
  onBack: () => void;
  confirmButton?: {
    disabled?: boolean;
    loading?: boolean;
  };
  isBackButtonVisible?: boolean;
};

const DepositAddIntegrationLayout = ({
  integration,
  children,
  onConfirm,
  confirmButton,
  onBack,
  isBackButtonVisible = true,
}: React.PropsWithChildren<Props>) => {
  const Icon = renderLogo(integration.provider as (typeof providers)[number]);

  return (
    <Fragment>
      <div className="space-y-6 p-6 pb-0">
        <div className="flex items-center gap-4">
          <div className="size-20 flex items-center justify-center shrink-0">
            {Icon && <Icon className="size-10" />}
          </div>
          <h4 className="text-xl grow">{integration.account}</h4>
        </div>
        <Separator />
      </div>

      <div className="min-h-[526px] px-6 pb-6 overflow-y-auto">{children}</div>

      <div className={cn('flex p-6 pt-0', isBackButtonVisible ? 'justify-between' : 'justify-end')}>
        {isBackButtonVisible && (
          <Button variant="outline" onClick={onBack}>
            <ArrowLeft />
            Back
          </Button>
        )}
        <Button onClick={onConfirm} disabled={confirmButton?.disabled} isLoading={confirmButton?.loading}>
          Add
        </Button>
      </div>
    </Fragment>
  );
};

export default DepositAddIntegrationLayout;
